import { render, staticRenderFns } from "./NsbDeposit.vue?vue&type=template&id=955b7c24&scoped=true&"
import script from "./NsbDeposit.vue?vue&type=script&lang=js&"
export * from "./NsbDeposit.vue?vue&type=script&lang=js&"
import style0 from "./NsbDeposit.vue?vue&type=style&index=0&id=955b7c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955b7c24",
  null
  
)

export default component.exports